import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanActivateChild } from '@angular/router';
import { UserRole } from 'src/app/shared/models/users/user';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class DataEntryGuard implements CanActivateChild {
    constructor(private authService: AuthService, private router: Router) { }
    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.canActivate(route, state);
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const role = this.authService.user.role;
        if (role == UserRole.ADMIN || role == UserRole.DATA_ENTRY) {
            return true;
        } else {
            this.router.navigate(['/']);
            return false;
        }
    }
}
